<template>
  <div>
    <div class="img-wrap flex-center">
      <img v-if="nowImg" class="now-img" :src="nowImg" alt="">
    </div>
    <div class="img-list flex">
      <div class="img-item flex-center" :class="nowIndex == index ? 'active' : ''" v-for="(item, index) in imgList" :key="index" @click="onChangeImg(index)">
        <img v-if="item.fileUrl" :src="item.fileUrl"/>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  props: {
    imgList: {
      type: Array,
      default: () => []
    },
    imgIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      nowImg: '',
      nowIndex: 0
    }
  },
  methods: {
    getImgUrl(i) {
      return this.imgList[i].fileUrl
    },

    onChangeImg(index) {
      this.nowIndex = index
      this.nowImg = this.getImgUrl(index)
    }
  },
  
  created() {
    this.nowImg = this.getImgUrl(this.imgIndex)
    this.nowIndex = this.imgIndex
  }
}
</script>

<style lang="less" scoped>
  .img-wrap {
    width: 100%;
    height: 400px;
    .now-img {
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }
  .img-list {
    margin-top: 10px;
    .img-item {
      width: 100px;
      height: 100px;
      border: 2px solid #eee;
      margin-left: 4px;
      cursor: pointer;
      &.active {
        border-color: @primary-color;
      }
      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: cover;
      }
    }
  }
</style>
